import { useMemo } from 'react'
import { message } from 'antd'
import { compose, hoc, useStore } from '@'
import { useForm, useFormLoading, useFormValues } from '@form'
import { withModalV4, useModal } from '@modal'
import UpdateRegion from '../../actions/UpdateRegion'
import { $regionCoverage } from '../../stores'
import { text } from '../CoverageCommon'

const NAME = 'RegionCoverageEditor'

const FIELDS = ['region_name', 'region_name_full', 'region_type', 'country_code']

const normalize = (field, value) => (field === 'country_code' ? text(value).toUpperCase() : text(value))

// Synced fields are disabled and taken from lst_region, so they must not block the submit.
const $fieldProps = syncing => ({
    region_name: { rules: [{ required: !syncing, whitespace: true, message: 'Region name is required' }] },
    region_type: { rules: [{ required: !syncing, message: 'Region type is required' }] },
    country_code: { rules: [{ pattern: /^\s*[A-Za-z]{2}\s*$/, message: 'Two-letter ISO country code' }] },
    sync_from_lst_region: { valuePropName: 'checked' }
})

const container = compose(
    hoc(props => {
        const { $modal } = props

        const [regionCoverage] = useStore([$regionCoverage])
        const $values = useFormValues(NAME)

        const [$props, $form] = useForm(() => {
            const onSubmit = async values => {
                const region = ($regionCoverage.getState() || {}).region || {}
                const body = {}
                if (values.sync_from_lst_region) {
                    body.sync_from_lst_region = true
                } else {
                    FIELDS.forEach(field => {
                        const value = normalize(field, values[field])
                        if (value && value !== normalize(field, region[field])) {
                            body[field] = value
                        }
                    })
                    if (!Object.keys(body).length) {
                        message.info('Nothing changed')
                        $modal.close()
                        return
                    }
                }
                if (values.supplier_code) {
                    body.supplier_code = values.supplier_code
                }
                await UpdateRegion(values.region_id, body)
                $modal.close()
            }

            return {
                name: NAME,
                onSubmit,
                props: { colon: false, layout: 'vertical', wrapperCol: { flex: 1 } }
            }
        }, [$modal])

        const $loading = useFormLoading($form.name)

        $modal.setForm($form)
        $modal.setLoading($loading)

        const syncing = !!($values && $values.sync_from_lst_region)

        return {
            lst: (regionCoverage && regionCoverage.region && regionCoverage.region.lst_region) || null,
            syncing,
            supplierCode: ($values && $values.supplier_code) || '',
            $form,
            $props,
            $loading,
            $fieldProps: useMemo(() => $fieldProps(syncing), [syncing]),
            ...props
        }
    }),
    withModalV4(props => {
        const $values = useFormValues(NAME)

        const regionId = $values && $values.region_id

        const [$props, $modal] = useModal(
            () => ({
                name: NAME,
                props: {
                    title: `Edit region ${regionId} metadata`,
                    destroyOnClose: true,
                    okText: 'Save'
                }
            }),
            [regionId]
        )

        return {
            $modal,
            $props,
            ...props
        }
    })
)

export default container
